import React, { createContext } from "react"
import { QuizItemWrapper, QuizOptions, QuizCounter } from "./quiz-item.style"

export const QuizItemContext = createContext()

const QuizItemFeedback = ({ explanation, selection }) => {
  if (!selection) return null
  return (
    <div className="quiz-item-feedback">
      <b>{selection.isCorrect ? "Richtig!" : "Falsch!"}</b>
      {explanation}
    </div>
  )
}

const QuizItem = (props) => {
  const { question, options, img, total, id, selection } = props
  return (
    <QuizItemContext.Provider value={{ id, selection }}>
      <QuizItemWrapper>
        <QuizCounter>
          {id + 1} / {total}
        </QuizCounter>
        {img}
        {question}
        <QuizOptions>{options}</QuizOptions>
        <QuizItemFeedback {...props} />
      </QuizItemWrapper>
    </QuizItemContext.Provider>
  )
}

export default QuizItem
